/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
  GetApiV1ExamDisciplineDropdownFilteredQueryParams,
  GetApiV1ExamDisciplineDropdownFiltered400,
  GetApiV1ExamDisciplineDropdownFiltered401,
  GetApiV1ExamDisciplineDropdownFiltered500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamDisciplineDropdownFiltered.ts";

function getGetApiV1ExamDisciplineDropdownFilteredUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/discipline-dropdown-filtered` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de disciplinas ativas para uso em componentes de seleção, com filtros opcionais por modalidade do curso, empresa, curso, sala de aula e texto. Quando classroomId é informado, retorna apenas disciplinas cuja modalidade corresponde ao tipo da sala de aula. Quando bringMain é verdadeiro, inclui disciplinas globais junto às disciplinas da empresa. **(Requer Authorization para autenticação)**
 * @summary Lista de disciplinas filtrada para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/discipline-dropdown-filtered}
 */
export async function getApiV1ExamDisciplineDropdownFiltered(
  params?: GetApiV1ExamDisciplineDropdownFilteredQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamDisciplineDropdownFiltered400
      | GetApiV1ExamDisciplineDropdownFiltered401
      | GetApiV1ExamDisciplineDropdownFiltered500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamDisciplineDropdownFilteredUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
